import { Component, inject, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonSpinner,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { EdroNetworkManager } from '../../../services/ecosystems/manager/edro-network-manager';

@Component({
  selector: 'app-not-connected-modal',
  templateUrl: './not-connected-modal.component.html',
  styleUrls: ['./not-connected-modal.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    TranslatePipe,
    IonSpinner,
  ],
})
export class NotConnectedModalComponent {
  private modalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public connectionInProgress = false;

  constructor() {}

  startConnection() {
    this.connectionInProgress = true;

    this.edroNetworkManager
      .connect(10000)
      .then((res) => {
        this.modalController.dismiss(true).finally(() => {});
      })
      .catch(() => {
        this.connectionInProgress = false;
      });
  }

  public async dismissModal() {
    await this.modalController.dismiss(false);
  }
}
